import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { API_URL } from '../utils/fatch';

export const AttractionProductsPage = () => {
    const { attractionId } = useParams(); // Gets '16966' from URL
    const [products, setProducts] = useState([]);

    useEffect(() => {
        const fetchProducts = async () => {
            // This endpoint should handle the logic we discussed:
            // Taking an attractionId and returning all linked product objects
            const response = await fetch(`${API_URL}/suggestions/${attractionId}/products`,
                {
                    method: 'GET',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                }
            );
            const data = await response.json();
            console.log(data);
            setProducts(data);
        };
        fetchProducts();
    }, [attractionId]);

    return (
        <div className="product-list-container">
            <h1>Experience available at this landmark</h1>
            <div className="product-grid">
                {products.map(product => (
                    <div key={product.productCode} className="product-card">
                        <img src={product.images[0].variants[0].url} alt={product.title} />
                        <h3>{product.title}</h3>
                        {/* <p>From ${product.pricing.summary.lowPrice}</p> */}
                        {/* Link to the final checkout/details page */}
                        <Link to={`/activity_details/${product.productCode}`}>Book Now</Link>
                    </div>
                ))}
            </div>
        </div>
    );
};